import styled from 'styled-components';

export const GameWrapper = styled.div`
  width: 100%auto;
  display: flex;
  align-items: center;
  outline: none;
  flex-direction: column;
`;

export const Score = styled.h1`
  background: linear-gradient(to left, ##2464F0, #132D68);
  --webkit-background-clip: text;
  --webkit-text-fill-color: transparent;
`;
